import classNames from 'classnames';
import { IconProps } from './types';
import { Bullhorn as BullhornIcon } from '@carbon/react/icons';

import style from './icons.module.scss';

const Bullhorn = ({ className }: IconProps) => {
  return (
    <div className={classNames(style.background, style.bullhorn, className)}>
      <BullhornIcon
        size={32}
        className={classNames(style.icon, style.bullhorn)}
      />
    </div>
  );
};

export default Bullhorn;
